export default __webpack_public_path__ + "static/media/black_arrow_up.e89f01b3.webp";